import styled from 'styled-components';

const getBorder = (invalid, isNoSale) => {
  if (invalid) return '2px solid red';
  if (isNoSale) return '1px solid gray';
  return '2px solid #009E0F';
};

export const Label = styled.label``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  & label {
    margin: 0px;
    font-size: 1em;
    font-weight: bold;
  }
  & input {
    ${(props) => `tabIndex: ${props.invalid ? 6 : 9}`};
    width: 95%;
    height: 50px;
    text-align: center;
    font-size: 2.1em;
    font-weight: bold;
    border: 1px solid gray;
    ${({ invalid, isNoSale, confirming }) => confirming
      && `border: ${getBorder(invalid, isNoSale)}`};
    border-radius: 3px;
    ::placeholder,
    -webkit-input-placeholder {
      font-size: 1em;
      color: rgba(255, 0, 0, 0.2);
    }
    :disabled {
      border: 1px solid gray;
    }
    &:focus {
      outline: none;
      background-color: rgba(0, 128, 0, 0.115);
    }
  }
`;

export default Container;
